import styled from 'styled-components';
import { colors } from '@keen.io/colors';

export const Container = styled.div`
  color: ${colors.black[100]};
  font-size: 14px;
  font-family: 'Lato Regular', sans-serif;
  width: 66px;
`;
